const storage = {
    saveUser(user) {
        localStorage.setItem(1, JSON.stringify(user));
    },
    getUser() {
        // return JSON.parse(localStorage.getItem() || '{}')
        return JSON.parse(localStorage.getItem(1) || null);
    },
    removeUser() {
        // localStorage.removeItem()
        localStorage.removeItem(1);
    },
};

export default storage;
